<template>
  <div class="popover-wrapper">
    <div
      class="popover"
      :style="{
        transform: `translateY(${translateY}px)`,
        transition: transitionEnabled ? 'transform 0.3s ease' : 'none'
      }"
      @mousedown="startDrag"
      @touchstart="startDrag"
    >
      <div class="title">
        <div class="title-text">
          <slot name="title"></slot>
        </div>
        <div @mousedown.stop @touchstart.stop @click="emits('close')" class="close-button">
          <el-icon><Close /></el-icon>
        </div>
      </div>
      <slot name="content"></slot>
    </div>
  </div>
</template>

<script setup lang="ts">
import { Close } from '@element-plus/icons-vue'
import { ref } from 'vue'

const emits = defineEmits(['close'])

const translateY = ref(0)
const transitionEnabled = ref(false)

let startY = 0
let isDragging = false

const startDrag = (event: MouseEvent | TouchEvent) => {
  event.preventDefault()
  isDragging = true
  transitionEnabled.value = false // Disable transition while dragging

  startY = event instanceof TouchEvent ? event.touches[0].clientY : event.clientY

  document.addEventListener('mousemove', onDrag)
  document.addEventListener('mouseup', endDrag)
  document.addEventListener('touchmove', onDrag)
  document.addEventListener('touchend', endDrag)
}

const onDrag = (event: MouseEvent | TouchEvent) => {
  if (!isDragging) return

  const currentY = event instanceof TouchEvent ? event.touches[0].clientY : event.clientY
  translateY.value = Math.max(0, currentY - startY)
}

const endDrag = () => {
  isDragging = false
  transitionEnabled.value = true

  if (translateY.value > 150) {
    emits('close')
  } else {
    translateY.value = 0
  }

  document.removeEventListener('mousemove', onDrag)
  document.removeEventListener('mouseup', endDrag)
  document.removeEventListener('touchmove', onDrag)
  document.removeEventListener('touchend', endDrag)
}
</script>

<style lang="scss">
.popover-wrapper {
  position: fixed;
  top: 0;
  left: 0;
  height: 100vh;
  width: 100vw;
  z-index: 100;

  .popover {
    border-radius: 25px 25px 0 0;
    background-color: white;
    padding: 20px;
    position: fixed;
    bottom: 0;
    left: 0;
    display: flex;
    width: 100vw;
    flex-direction: column;
    gap: 20px;
    flex-wrap: nowrap;
    justify-content: flex-end;
    align-items: center;
    .title {
      display: grid;
      grid-template-columns: 20px 1fr 20px;
      font-size: 22px;
      width: 100%;
      .title-text {
        grid-column: 2;
        text-align: center;
      }
      .close-button {
        grid-column: 3;
        margin-left: auto;
        justify-self: end;
      }
    }
  }
}
</style>
